<template>
  <v-dialog
    v-model="showDialog"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title>Edit Asset</v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter.native="save()"
        >
          <v-select
            ref="assetType"
            v-model="assetType"
            :items="assetTypeList"
            item-text="label"
            item-value="id"
            :rules="[validateRequired]"
            label="Type"
            required
            @input="assetTypeDirty = true"
          />
          <v-text-field
            ref="assetId"
            v-model="assetId"
            :rules="[validateRequired]"
            label="Asset ID"
            required
            @blur="assetIdDirty = true"
          />
          <v-text-field
            ref="assetName"
            v-model="assetName"
            :rules="[validateRequired]"
            label="Asset Name"
            required
            @blur="assetNameDirty = true"
          />
          <v-textarea
            ref="details"
            v-model="details"
            :rules="[validateRequired]"
            label="Details"
            required
            rows="3"
            @blur="detailsDirty = true"
          />
          <v-select
            ref="currencyType"
            v-model="currencyType"
            :items="currencyTypeList"
            item-text="label"
            item-value="id"
            :rules="[validateRequired]"
            label="Currency"
            required
            @blur="currencyTypeValueDirty = true"
          />
          <v-text-field
            ref="assetValue"
            v-model="assetValue"
            :rules="[validateRequired]"
            label="Value"
            type="number"
            required
            @blur="assetValueDirty = true"
          />
          <v-select
            ref="documentId"
            v-model="documentId"
            :items="docs"
            item-value="id"
            item-text="name"
            label="Document"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          small
          text
          @click.stop="close()"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="!valid || submitting"
          :loading="submitting"
          color="primary"
          small
          @click.stop="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validateRequired } from '@/utils/validationRules'
import { CURRENCIES_LIST } from '@/dataAccess/currencies'
import { ASSET_TYPES_LIST } from '@/dataAccess/assetTypes'
import { getAssetRef } from '@/dataAccess/assets'

export default {
  name: 'EditAssetDialog',
  data: function () {
    return {
      showDialog: false,
      valid: false,
      assetId: null,
      assetIdDirty: false,
      assetType: null,
      assetTypeDirty: false,
      assetName: null,
      assetNameDirty: false,
      details: null,
      detailsDirty: false,
      assetValue: null,
      currencyType: null,
      assetValueDirty: false,
      submitting: false,
      assetTypeList: ASSET_TYPES_LIST,
      currencyTypeValueDirty: false,
      currencyTypeList: CURRENCIES_LIST,
      documentId: null
    }
  },
  computed: {
    docs: function () {
      return this.vaultDocumentsLoading ? [] : this.vaultDocuments.map((item) => ({
        name: item.name,
        id: item.id
      }))
    }
  },
  beforeCreate() {
    this.dispatchActions(['get_account', 'get_appUser', 'get_vaultDocuments'])
    this.mapStates(['account', 'appUser', 'vaultDocuments', 'vaultDocumentsLoading'])
  },
  methods: {
    validateRequired,
    open(asset) {
      this.id = asset.id
      this.assetId = asset.assetId
      this.assetName = asset.assetName
      this.assetType = asset.assetType
      this.assetValue = asset.assetValue
      this.details = asset.details
      this.entryasset = asset.entryasset
      this.currencyType = asset.currencyType
      this.documentId = asset.documentId
      this.showDialog = true
    },
    async save() {
      Object.entries(this.$data).forEach(([key, value]) => {
        if (key.includes('Dirty')) {
          this[key] = true
        }
      })

      if (this.$refs.form.validate()) {
        this.$handlingError(`Error updating asset "${this.assetName}"`, async () => {
          this.submitting = true
          const payload = {
            assetId: this.assetId,
            assetName: this.assetName,
            assetType: this.assetType,
            details: this.details,
            assetValue: this.assetValue,
            documentId: this.documentId,
            currencyType: this.currencyType
          }

          const assetRef = getAssetRef(this.id)

          await assetRef.update(payload)

          this.close()
          this.$showSuccessbar('Asset updated')
          this.submitting = false
        })
      }
    },
    close() {
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
